import { useEffect, useState, useCallback } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useLazyQuery, gql } from "@apollo/client";
import NestedTable from "./NestedTable";
import { useOutletContext } from 'react-router-dom';

const ESTAR_COLUMNS = [
	{
		id: "tableOfContent",
		label: "DHF Table of Content",
		align: "left",
	},
	{
		id: "dueDate",
		label: "Due Date",
		width: 150,
		align: "center",
	},
	{
		id: "percentageComplete",
		label: "% Complete",
		width: 150,
		align: "center",
	},
];

const EStarView = () => {
	const { navigateToWizard, ideaId } = useOutletContext();
	const [documentsData, setDocumentsData] = useState([]);

	const GET_DOCUMENTS_GQL = gql`
		query GetDocumentsData($ideaId: ID!) {
			idea(id: $ideaId) {
				estarDocument {
					completionRate
					dueOn
					sections {
						id
						title
						completionRate
						dueOn
						templates {
							id
							title
							completionRate
							dueOn
							docusignId
						}
					}
				}
			}
		}
	`;

	const [getDocumentsData, { loading }] = useLazyQuery(GET_DOCUMENTS_GQL, {
		fetchPolicy: "no-cache",
	});

	const handleGetDocumentsData = useCallback(() => {
		getDocumentsData({
			variables: {
				ideaId,
			},
		})
			.then((res) => {
				setDocumentsData([res?.data?.idea?.estarDocument]);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [getDocumentsData, ideaId]);

	useEffect(() => {
		handleGetDocumentsData();
	}, [handleGetDocumentsData]);

	return (
		<Box
			sx={{
				display: "flex",
				padding: "0rem 4rem",
			}}
		>
			{loading ? (
				<Box
					sx={{
						display: "flex",
						height: "400px",
						width: "100%",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<CircularProgress />
				</Box>
			) : (
				<NestedTable
					view={"ESTAR"}
					columns={ESTAR_COLUMNS}
					records={documentsData}
					navigateToWizard={navigateToWizard}
				/>
			)}
		</Box>
	);
};

export default EStarView;
